export const SKELETON_6_ITEM= [1,2,3,4,5,6]
export const SKELETON_5_ITEM= [1,2,3,4,5]
export const SKELETON_4_ITEM= [1,2,3,4]
export const SKELETON_3_ITEM= [1,2,3]
export const SKELETON_2_ITEM= [1,2]


export const ads = {
    pc:{
      leader_board:'jnmyw4lc',
      slider_logo:'jnmyx3h4',
      ballon:'jnmyz67s',
      r_1:'jnmyxo2z',
      r_2:'jnmyy4c7',
      r_3:'jnmyyov1',
      
    },
    mobile:{
      mashead:'jnmz0hvi',
      slider_logo:'jnmz34ef',
      cashfish:'jnmz3rap',
      r_1:'jnmz1242',
      r_2:'jnmz1ura',
      r_3:'jnmz2jcg'
    }

  }
